var map = {
	"./Cloud-Moon.svg": "e4f8",
	"./Cloud-Rain.svg": "0176",
	"./Cloud-Sun.svg": "8f13",
	"./Cloud.svg": "083c",
	"./Sun.svg": "d647",
	"./Thermometer.svg": "e164",
	"./Wind.svg": "9669"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bd0";